export const MenuTranslations = {
  MyAccount: 'modules.myAccount.title',
  SignOut: 'components.form.signOut',
};
